import { Button, Modal } from 'antd';
import styled from 'styled-components';

export const StyledModalFooter = styled.div`
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 24px 40px;
`;

export const StyledModalHeaderWrapper = styled.header`
    display: flex;
    justify-content: space-between;
    padding: 24px 40px;
    width: 100%;
    background-color: #f4f3fa;
`;

export const StyledModalBody = styled.div`
    padding-inline: 40px;
    padding-top: 24px;
`;

export const StyledModal = styled(Modal)<{ hideCloseButton?: boolean }>`
    ${({ hideCloseButton }) =>
        hideCloseButton &&
        `
            .ant-modal-close {
                display: none;
            }
        `}
    border-radius: 6px;
    overflow: hidden;
    min-width: 80ch;

    .ant-modal-footer {
        padding: 0;
    }

    .ant-modal-title {
        font-weight: 600;
        color: var(--brand-9);
        font-size: 20px;
        line-height: 28px;
    }

    .ant-modal-content {
        width: 100%;
        border-radius: 6px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
`;

export const StyledFilterModalCloseButton = styled(Button)`
    && {
        border: none;
        background: transparent;
        box-shadow: none;

        &:hover,
        &:focus,
        &:active {
            border: none;
            outline: none;
            color: var(--brand-5);
        }

        & svg {
            font-size: 16px;
        }
    }
`;
